import React from 'react';
import { Tabs, Dropdown, Button, Icon, Menu} from 'antd';
import GraphDistributionCluster from '../../components/GraphDistributionCluster';
import GraphAmountCluster from '../../components/GraphAmountCluster';
const TabPane = Tabs.TabPane;

class CategorySpecsRender extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      category: '',
    }
  }

  setFilter = (translated, category) => {
    console.log('tttt', translated, category);
    this.setState({category: translated})
    this.props.changeCategory(category)
  }

  menuCategory = () => {
    const t = this.props.t;
    let categories;
    if (this.props.categories) {
      categories = this.props.categories.map( category => category[1].name)

    }
    return (
      <Menu style={styles.dropdown} onClick={(e) => this.setFilter(e.item.props.children, e.key)}>
        {categories && categories.map( (category, i) =>
          <Menu.Item key={category}>{t(category)}</Menu.Item>
          )
        }
      </Menu>
    )
  }

  componentDidUpdate() {
    const { t } = this.props
    if (this.props.categories) {
      if (this.state.category == '') {
        console.log('ookokook');
        this.props.categories[0] && this.setState({category: t(this.props.categories[0][1].name)})
      }
    }
  }

  render() {

    let colors;
    switch (this.state.category) {
      case 'Research':
        colors= {
          color1:'#4A1786',
          color2:'#6c3aaa',
          shades: ['#4A1786', '#6f45a5', '#7a4bb7', '#9068c4', '#a27cd3' ]
        }
        break;
      case 'Thinking':
        colors = {
          color1:'#51CA5C',
          color2:'#1A6220',
          shades: ['#0DA925', '#2aba40', '#4ad35e', '#6ae27a', '#88f796']
        }
        break;
      case 'Self-Management':
        colors= {
          color1:'#D37D91',
          color2:'#EDADBA',
          shades: ['#D37D91', '#bf6578', '#c1435d', '#bc2543', '#c1092e']
        }
        break;
      case 'Social':
        colors = {
          color1:'#002538',
          color2:'#164e6b',
          shades: ['#002538', '#074666', '#0d6591', '#0f7daf', '#0c94ce']
        }
        break;
      case 'Communication':
        colors = {
          color1:'#613413',
          color2:'#9b663f',
          shades: ['#613413', '#894f26', '#a8673c', '#c68055', '#eaa47c']
        }
        break;
      default:
        colors = {
          color1:'#4A1786',
          color2:'#6c3aaa',
          shades: ['#4A1786', '#5b2999', '#7a4bb7', '#9068c4', '#a27cd3' ]
        }
    }

    const { t, currentYear, allYears, gradeSelected } = this.props
    const yearTabs = gradeSelected ? [{text: 'Selected class'}] : allYears

    return (
      <div>
        <div style={styles.container} className="card-container">
          <Tabs
            type="card"
            activeKey={currentYear.year && !gradeSelected  ? currentYear.year.text : 'Selected class'}
            onTabClick={(year) => !gradeSelected && this.props.changeYear(allYears.filter( item => item.text === year)[0])}
          >
          {yearTabs && yearTabs.map( year => (
              <TabPane
                style={styles.yearbox}
                tab={year.text}
                key={year.text}>
                <p style={styles.paragraph}>{t('Please select a category')}</p>
                <Dropdown overlay={this.menuCategory()}>
                  <Button style={styles.button}>
                  {this.state.category}<Icon type="down" />
                  </Button>
                </Dropdown>
                <p style={styles.title}>{t('Amount Per Cluster')}</p>
                <GraphAmountCluster t={this.props.t} data={this.props.amount} colors={colors} />
              </TabPane>
            ))}
          </Tabs>
        </div>

        <div style={styles.container2}>
          <p style={styles.title2}>{t('Distribution Per Cluster')}</p>
          <div style={styles.innerFlex}>
            <GraphDistributionCluster data={this.props.distribution}  colors={colors} t={t}/>
            <div style={styles.colorbox}>
            {this.props.distribution.map( (name, i) =>
              <div style={{marginBottom: '15px'}}><div className="circle" style={{backgroundColor: colors.shades[i]}} /> {t(name.name)}</div>
            )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CategorySpecsRender;

const styles = {

  yearbox: {
    backgroundColor: 'white',
    padding: '40px 20px'
  },

  container: {
    margin: '0px 20px 20px 20px',
  },

  container2: {
    margin: '20px',
    backgroundColor: 'white',
    padding: '40px',
    height: 490
  },

  title: {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 40,
    paddingTop: 30,
  },

  title2 : {
    fontSize: '20px',
    color: '#485465',
    fontWeight: 600,
    marginLeft: 100,
  },

  innerFlex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },

  colorbox: {
    fontSize: '16px'
  },

  paragraph: {
    fontSize: '16px',
    marginLeft: '40px'
  },

  dropdown: {
    width: '285px',
    padding: '20px',
  },

  button: {
    borderRadius: '25px',
    width: '160px',
    marginLeft: '40px',
  },

}



// WEBPACK FOOTER //
// ./src/components/CategorySpecsRender/index.jsx